import { useState, useCallback } from "react";
const DEFAULT_PREFS = {
    template: "modern",
    overrides: {},
    autoInsert: true,
};
function storageKey(upn) {
    return `sig_prefs_${upn}`;
}
function loadPrefs(upn) {
    try {
        const raw = localStorage.getItem(storageKey(upn));
        if (!raw)
            return DEFAULT_PREFS;
        return Object.assign(Object.assign({}, DEFAULT_PREFS), JSON.parse(raw));
    }
    catch (_a) {
        return DEFAULT_PREFS;
    }
}
function savePrefs(upn, prefs) {
    try {
        localStorage.setItem(storageKey(upn), JSON.stringify(prefs));
    }
    catch (_a) {
        // localStorage may be unavailable in some sandboxed contexts — fail silently
    }
}
/**
 * Hook for reading and persisting signature preferences per user.
 * Preferences are stored in localStorage keyed by the user's UPN so
 * they survive task pane close/reopen.
 */
export function useSignaturePrefs(upn) {
    const [prefs, setPrefsState] = useState(() => upn ? loadPrefs(upn) : DEFAULT_PREFS);
    const updatePrefs = useCallback((updates) => {
        setPrefsState((current) => {
            const next = Object.assign(Object.assign({}, current), updates);
            if (upn)
                savePrefs(upn, next);
            return next;
        });
    }, [upn]);
    const resetPrefs = useCallback(() => {
        if (upn)
            savePrefs(upn, DEFAULT_PREFS);
        setPrefsState(DEFAULT_PREFS);
    }, [upn]);
    return { prefs, updatePrefs, resetPrefs };
}
